/**
 * The "Architect / Designer" lead source, and the name field it reveals.
 *
 * Matched on the stored value: the label is a company's to rename, so a label
 * match would break the moment an admin edits it.
 */
export const LEAD_SOURCE_ARCHITECT = "architect_designer"

export const ARCHITECT_NAME_MAX_LENGTH = 255

export function isLeadSourceArchitect(
  sourceValue: string | null | undefined
): boolean {
  return sourceValue === LEAD_SOURCE_ARCHITECT
}
